import clsx from "clsx"
import { type ReactElement, memo } from "react"
import { Card } from "@/ui/Card"
import { type ICardList } from "./types"

export const CardList = memo(function CardList({
  items,
  isMatchActive,
  onClickCard
}: ICardList): ReactElement[] {
  return items.map((el) => (
    <Card
      {...el}
      className={clsx("box", el.status)}
      dataFlipId={`card-${el.id}`}
      isMatchActive={isMatchActive}
      onClick={
        onClickCard
          ? () => {
              onClickCard(el.data)
            }
          : undefined
      }
      key={`card-${el.id}`}
    >
      {el.id}
    </Card>
  ))
})
